<template>
  <v-popover
    style=".trigger{width: 200%}"
    offset="4"
    placement="top-end"
    :open="show_filter"
  >
    <button @click="show_filter = !show_filter" class="btn text-secondary btn-sm btn-link float-right pr-0">{{ $t("common.edit_task.more_options") }}</button>

    <template slot="popover">
      <ul
        @click="show_filter = !show_filter"
        class="select2-results__options">
        <li
          @click="duplicateTask"
          class="select2-results__option select2-results__option--highlighted p-0 mt-1"
          style="cursor: pointer; min-width: 170px">
          <i class="fe fe-copy mr-2"></i>
          {{ $t("common.edit_task.duplicate_task") }}
        </li>
        <li
          @click="renameTask"
          class="select2-results__option select2-results__option--highlighted p-0 mt-1"
          style="cursor: pointer; min-width: 170px">
          <i class="fe fe-edit-3 mr-2"></i>
          {{ $t("common.edit_task.rename_task") }}
        </li>
        <!--<li
          @click="copyLink"
          class="select2-results__option select2-results__option&#45;&#45;highlighted p-0 mt-1"
          style="cursor: pointer; min-width: 170px">
          <i class="fe fe-edit-3 mr-2"></i>
          Copy Link to Task
          <input type="hidden" id="copied-url" :value="copiedUrl">
        </li>-->
      </ul>
    </template>

  </v-popover>
</template>

<script>
  import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
  import { mapGetters } from 'vuex';

  export default {
    name: "EditTaskOptions",
    data () {
      return {
        show_filter: false
      }
    },
    props: {
      taskId: {
        default: ''
      }
    },
    computed: {
      ...mapGetters([
        'task_template',
        'selected_task',
      ]),
      copiedUrl: function () {
        return window.location.href;
      }
    },
    components: {
      'v-popover': VPopover,
    },
    directives: {
      'tooltip': VTooltip,
      'close-popover': VClosePopover,
    },
    methods: {
      renameTask () {
        this.$emit('rename-task');
      },
      duplicateTask () {
        this.task_template.name = this.selected_task.name;
        this.task_template.description = this.selected_task.description;
        this.task_template.project_id = this.selected_task.project_id;
        this.task_template.deadline_date = this.selected_task.deadline_date;
        this.task_template.deadline_period = this.selected_task.deadline_date;
        this.task_template.status = this.selected_task.status;
        this.task_template.type = this.selected_task.type;
        this.task_template.assignee = this.selected_task.assignee;
        this.task_template.created_by = this.selected_task.created_by;
        this.task_template.duration = this.selected_task.duration;
        this.task_template.priority = this.selected_task.priority;
        this.task_template.epic_links = this.selected_task.epic_links;
        this.task_template.plan_date = this.selected_task.plan_date;
        this.task_template.deadline_date = this.selected_task.deadline_date;
        this.task_template.section_id = this.selected_task.section_id;

        this.$store.commit('showModal', 'create_task')
        this.$emit('duplicate-task');
      },
      copyLink () {
        let urlToCopy = document.querySelector('#copied-url');
        urlToCopy.setAttribute('type', 'text');
        urlToCopy.select();

        try {
          let successful = document.execCommand('copy');
          let msg = successful ? 'successful!' : 'unsuccessful';
          this.$noty.show("Copied " + msg);
        } catch (err) {
          this.$noty.error('Oops, unable to copy');
        }

        /* unselect the range */
        urlToCopy.setAttribute('type', 'hidden');
        window.getSelection().removeAllRanges();
      }
    }
  }
</script>

<style>
  .tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border: 0;
    position: absolute;
    z-index: 1;
  }
</style>

<style scoped>
  .v-popover {
    display: inline-block;
    float: right;
  }

  .select2-results__options {
    /*transition-duration: .2s;*/
  }

  li {
    font-size: 1.2em;
    padding: 15px !important;
    color: black;
    cursor: pointer !important;
    text-align: left;
  }

  li:hover {
    background-color: #F0F2F5;
    color: black;
  }

</style>
